import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useApi } from "../../hooks/useApi";
import { Button } from "../ui/button";
import { DateField } from "../DateField";

export function GmCover() {
  const { data: users } = useApi("/admin/users");
  const { data } = useApi("/admin/gm-cover");
  const [f, setF] = useState({ user_id: "", start: "", end: "" });
  useEffect(() => { if (data) setF({ user_id: data.user_id || "", start: data.start || "", end: data.end || "" }); }, [data]);
  const epil = (users || []).filter((u) => !u.partner_id && !(u.roles || []).includes("GM"));
  const save = async () => {
    try { await api.put("/admin/gm-cover", { user_id: f.user_id || null, start: f.start || null, end: f.end || null }); toast.success("GM cover saved"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-6 rounded-xl border bg-card p-6" data-testid="gm-cover-settings">
      <div className="eyebrow">Drawdown approvals</div>
      <h2 className="mt-1 font-heading text-lg font-bold">GM cover</h2>
      <p className="mt-1 text-sm text-muted-foreground">Who can do the GM check while the GM is away. Leave the dates blank for open-ended cover; choose “No cover” to switch it off.</p>
      <div className="mt-4 grid gap-3 sm:grid-cols-3">
        <label className="text-sm">Cover person
          <select className="mt-1 h-9 w-full rounded-md border bg-background px-2 text-sm" value={f.user_id} onChange={(e) => setF({ ...f, user_id: e.target.value })} data-testid="gm-cover-user">
            <option value="">No cover</option>
            {epil.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
          </select>
        </label>
        <label className="text-sm">From<DateField value={f.start} onChange={(v) => setF({ ...f, start: v })} testid="gm-cover-start" className="mt-1" /></label>
        <label className="text-sm">Until<DateField value={f.end} onChange={(v) => setF({ ...f, end: v })} testid="gm-cover-end" className="mt-1" /></label>
      </div>
      <Button className="mt-4" onClick={save} data-testid="gm-cover-save">Save GM cover</Button>
    </div>
  );
}
